import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { can, readUser } from "../utils/perm";

export default function RequirePerm({ page, action = "View", children }) {
  const token =
    localStorage.getItem("token") || sessionStorage.getItem("token");
  const userData =
    localStorage.getItem("userData") || sessionStorage.getItem("userData");
  const location = useLocation();

  if (!token || !userData) {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  // MASTER can access any page
  const role = readUser()?.rolename?.roleName;
  if (role === "MASTER") return children;

  if (!can(page, action)) {
    // optionally send to a dedicated "403" page
    return <Navigate to="/404" replace />;
  }

  return children;
}
